import { money } from '../../core/format/currency'
import { plural } from '../../core/format/text'
import { fromIso, fullDate } from '../../core/format/dates'
import type { LedgerEntryKind, LedgerUnit, VoucherSource, VoucherStatus, VoucherValidFor } from '../../core/types/vouchers'

/** Labels en kleine hulpjes voor Cadeaubonnen & tegoed. Pure functies, zonder React. */

type Tone = 'accent' | 'soft' | 'neutral' | 'success'

export const voucherStatusBadge: Record<VoucherStatus, { label: string; tone: Tone }> = {
  actief: { label: 'Actief', tone: 'success' },
  leeg: { label: 'Gebruikt', tone: 'neutral' },
  verlopen: { label: 'Verlopen', tone: 'neutral' },
  geblokkeerd: { label: 'Geblokkeerd', tone: 'accent' },
}

export const statusOptions: { value: VoucherStatus; label: string }[] = [
  { value: 'actief', label: 'Actief' },
  { value: 'leeg', label: 'Helemaal gebruikt' },
  { value: 'verlopen', label: 'Verlopen' },
  { value: 'geblokkeerd', label: 'Geblokkeerd' },
]

export const asVoucherStatus = (v: string | null): VoucherStatus | undefined => statusOptions.find((o) => o.value === v)?.value

export const validForLabel: Record<VoucherValidFor, string> = {
  all: 'Behandelingen en producten',
  treatments: 'Alleen behandelingen',
}

export const sourceLabel: Record<VoucherSource, string> = {
  webshop: 'Gekocht in de webshop',
  kassa: 'Verkocht in de salon',
  handmatig: 'Handmatig gemaakt',
}

export const ledgerKindLabel: Record<LedgerEntryKind, string> = {
  uitgegeven: 'Uitgegeven',
  ingewisseld: 'Ingewisseld',
  vervallen: 'Vervallen',
  correctie: 'Correctie',
}

/** Een bedrag of aantal in zijn eigen eenheid, met teken: "+ € 15,00", "− 1 behandeling". */
export function signedAmount(unit: LedgerUnit, amount: number): string {
  const sign = amount < 0 ? '−' : '+'
  const abs = Math.abs(amount)
  return `${sign} ${unit === 'cents' ? money(abs) : plural(abs, 'behandeling', 'behandelingen')}`
}

/** Saldo in zijn eigen eenheid, zonder teken. */
export const unitBalance = (unit: LedgerUnit, amount: number) => (unit === 'cents' ? money(amount) : plural(amount, 'behandeling', 'behandelingen'))

export const untilLabel = (validUntil: string) => fullDate(fromIso(validUntil))
